import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getRankingMonth } from './mapper/getRankingMonth';
import { getRankingWeek } from './mapper/getRankingWeek';

export const pointRankingQueryKey = createQueryKeys('point', {
  rankingMonth: {
    queryFn: async () => {
      const response = await getRankingMonth();
      return response;
    },
    queryKey: null,
  },
  rankingWeek: {
    queryFn: async () => {
      const response = await getRankingWeek();
      return response;
    },
    queryKey: null,
  },
});
